import { useState } from 'react';
import { DISMISSAL_REASONS, type DismissalReason } from '@ederest/contracts';
import { Button } from '../ui/Button.js';
import { DISMISSAL_REASON_LABEL } from './labels.js';

interface DismissDialogProps {
  title: string;
  busy?: boolean;
  onConfirm: (reason: DismissalReason, note: string | undefined) => void;
  onCancel: () => void;
}

/**
 * Dismissal with a reason from the closed list (functional §5.6). The
 * recommendation is never proposed again identically; the note is optional
 * and never a personal data container (back-office wording only).
 */
export function DismissDialog({ title, busy, onConfirm, onCancel }: DismissDialogProps) {
  const [reason, setReason] = useState<DismissalReason | null>(null);
  const [note, setNote] = useState('');

  return (
    <div className="dismiss" role="dialog" aria-modal="true" aria-labelledby="dismiss-title">
      <div className="dismiss__panel">
        <h3 id="dismiss-title" className="dismiss__title">
          {title}
        </h3>
        <p className="dismiss__hint">
          Une recommandation écartée n'est pas reproposée à l'identique. Choisissez le motif.
        </p>
        <fieldset className="dismiss__reasons">
          <legend className="dismiss__legend">Motif</legend>
          {DISMISSAL_REASONS.map((value) => (
            <label key={value} className="dismiss__reason">
              <input
                type="radio"
                name="dismissal-reason"
                value={value}
                checked={reason === value}
                onChange={() => setReason(value)}
              />
              <span>{DISMISSAL_REASON_LABEL[value]}</span>
            </label>
          ))}
        </fieldset>
        <label className="guidance__field">
          <span>Précision (facultative)</span>
          <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} maxLength={500} />
        </label>
        <div className="dismiss__actions">
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Annuler
          </Button>
          <Button
            variant="danger"
            disabled={!reason || busy}
            onClick={() => reason && onConfirm(reason, note.trim() || undefined)}
          >
            Écarter
          </Button>
        </div>
      </div>
    </div>
  );
}
